import React, { useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import StethoscopeIcon from "../assets/images/stethoscope.svg"
import { OMNICURIS_URL } from "../services/environments"
import Experts from "./Experts"
import ItemsList from "./ItemsList"
import { CaretRightOutlined } from "@ant-design/icons"
import Img from "./Img"
import { DefaultProfileIcon } from "../utilities/resources"
import { redirectToOmnicuris } from "../utilities"
import { isMobile } from "react-device-detect"
import { INITIATE_AUTH_DRAWER } from "../actions/types"
import { isAuthenticated } from "../utilities"
import authentication from "./authentication"

function Tiles(props) {
  const { courseId, title, media, courseSlug, speciality, experts, platformType, index } = props
  const { domainDetails } = useSelector((state) => state.listings)
  const boxRef = useRef(null)
  const history = useHistory()
  const dispatch = useDispatch()

  const navigate = (ev) => {
    ev.stopPropagation()
    if (!isAuthenticated() && window.self === window.top) {
      dispatch({
        type: INITIATE_AUTH_DRAWER,
      })
    } else {
      // if (domainDetails && domainDetails.orgType === 'certifier') {
      //   if (platformType === 'CME') {
      //     redirectToOmnicuris(`/academics/${courseSlug}`,window.self != window.top);
      //   } else {
      //     redirectToOmnicuris(`/oc-originals/${courseSlug}`,window.self != window.top);
      //   }
      // } else {
      history.push(`/academics/${courseSlug}`)
      // }
    }
  }

  return (
    <div>
      <section className="tiles">
        <figure onClick={navigate} className="tilesMedia">
          {!isMobile && <div className="tilesOverlay" />}
          <img src={media} alt="" />
          {!isMobile && <CaretRightOutlined className="playButton" onClick={navigate} />}
        </figure>
        <article ref={boxRef}>
          <h5 onClick={navigate}>{title}</h5>
          <div className="tilesSpeciality">
            {Array.isArray(speciality) ? (
              <ItemsList itemsList={speciality} path={["name"]} limit={1} itemStyleClass="tilesList" moreStyleClass="" separator={"|"} morePrefix={""} />
            ) : (
              <p>
                <img src={StethoscopeIcon} alt="" />
                {speciality}
              </p>
            )}
          </div>
          <div className="hrline" style={{ visibility: experts.length === 0 ? "hidden" : "" }}></div>
          {experts.length === 1 ? (
            <div className="singleExpertGrid">
              <div className="expertsDp">
                <Img src={experts[0].profilePic} defaultSrc={DefaultProfileIcon} alt="" />
              </div>
              <div className="expertInfo">
                <span>{experts[0].name}</span>
                <span>{experts[0].qualification}</span>
              </div>
            </div>
          ) : experts && experts.length > 1 ? (
            <Experts data={experts} containerRef={boxRef} fixedLimit={window.innerWidth < 550 ? 2 : null} />
          ) : null}
        </article>
      </section>
    </div>
  )
}

export default Tiles
